<micro-lookup domain="auth" obj="contactCompanies" url="/contactCompanies" [key]="contactCompanyId" [link]="link"></micro-lookup>
